import React, { useEffect, useState } from 'react'
import { FaFacebookF, FaInstagram, FaWhatsapp } from 'react-icons/fa'
import scrollToTop from '../helpers/scrollToTop'
import bannerImage from '../images/banner-image.jpg'
import BookingButton from '../components/BookingButton'

const TELEFONE = '+351 933 817 786'
const TELEFONE_URL = 'tel:+351933817786'
const WHATSAPP_NUMERO = '351933817786'
const EMAIL = 'yourmoment.mariaelara@gmail.com'
const MORADA_LINHAS = ['Av. João Corte Real 158', 'Praia da Barra', '3830-751 Gafanha da Nazaré']
const MORADA = `${MORADA_LINHAS.join(', ')}, Portugal`
const MAPA_URL =
  'https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent(`Your Moment Estética, ${MORADA}`)

// A maioria das visitas é de telemóvel: telefone, email e morada abrem
// diretamente a aplicação certa em vez de serem texto que não faz nada.
const CONTACT_DETAILS = [
  { label: 'Telefone', lines: [TELEFONE], href: TELEFONE_URL },
  { label: 'Email', lines: [EMAIL], href: `mailto:${EMAIL}`, compact: true },
  { label: 'Morada', lines: MORADA_LINHAS, href: MAPA_URL, external: true },
  { label: 'Horário', lines: ['Segunda a Sábado: 9h às 19h', 'Domingo: fechado'] },
]

const SOCIAL_LINKS = [
  {
    label: 'Instagram',
    href: 'https://www.instagram.com/your_moment_estetica',
    Icon: FaInstagram,
  },
  {
    label: 'Facebook',
    href: 'https://www.facebook.com/people/Your-Moment-Estética/61581622021802/',
    Icon: FaFacebookF,
  },
  { label: 'WhatsApp', href: `https://wa.me/${WHATSAPP_NUMERO}`, Icon: FaWhatsapp },
]

const ICON_PATHS = {
  Telefone:
    'M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z',
  Email: 'M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z',
  Morada:
    'M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0zM15 11a3 3 0 11-6 0 3 3 0 016 0z',
  Horário: 'M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z',
}

const ASSUNTOS = ['Informação Geral', 'Agendamento', 'Preços', 'Cancelamento', 'Outros']

const ESTADO_INICIAL = { nome: '', assunto: ASSUNTOS[0], mensagem: '' }

// Mesmo tratamento visual em todos os campos do formulário.
const CAMPO_CLASSES =
  'w-full px-4 py-2.5 bg-[#F5F1E9]/60 border border-stone-200 rounded-xl text-[#5c7160] ' +
  'placeholder:text-[#5c7160]/40 focus:outline-none focus:ring-2 focus:ring-[#a5bf99]/50 ' +
  'focus:border-[#a5bf99] focus:bg-white transition-colors'

const ContactIcon = ({ name }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="h-6 w-6 text-[#5c7160]"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    aria-hidden="true"
  >
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d={ICON_PATHS[name]} />
  </svg>
)

// Título de cartão com o sublinhado verde usado no resto do site.
const CardTitle = ({ children }) => (
  <h4 className="text-2xl font-light text-[#5c7160] mb-6 relative inline-block">
    {children}
    <span className="absolute -bottom-1 left-0 w-12 h-0.5 bg-[#a5bf99]"></span>
  </h4>
)

const Campo = ({ id, label, children }) => (
  <div>
    <label htmlFor={id} className="block text-sm text-[#5c7160]/80 mb-1.5">
      {label}
    </label>
    {children}
  </div>
)

function Contact() {
  useEffect(() => {
    scrollToTop()
  }, [])

  const [formData, setFormData] = useState(ESTADO_INICIAL)
  const [enviado, setEnviado] = useState(false)

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData((prev) => ({ ...prev, [name]: value }))
  }

  // Não há backend nem serviço de email: o formulário monta a mensagem e
  // entrega-a ao WhatsApp do estúdio, que é onde o atendimento acontece.
  const construirLinkWhatsApp = () => {
    const texto = [
      `Olá! Sou ${formData.nome.trim()}.`,
      `Assunto: ${formData.assunto}`,
      '',
      formData.mensagem.trim(),
    ].join('\n')

    return `https://wa.me/${WHATSAPP_NUMERO}?text=${encodeURIComponent(texto)}`
  }

  const handleSubmit = (e) => {
    e.preventDefault()

    const url = construirLinkWhatsApp()
    // Alguns browsers em iOS bloqueiam window.open mesmo dentro do gesto;
    // nesse caso navegamos na própria janela em vez de falhar em silêncio.
    const janela = window.open(url, '_blank', 'noopener,noreferrer')
    if (!janela) window.location.href = url

    setEnviado(true)
  }

  return (
    <div className="min-h-screen bg-[#F5F1E9]">
      {/* Hero Section */}
      <div className="relative">
        <img
          className="object-cover h-[22vh] min-h-[140px] sm:h-[26vh] md:h-[30vh] w-full"
          src={bannerImage}
          alt="Estúdio Your Moment Estética"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#c0a080]/40 to-[#c0a080]/70"></div>
        <div className="absolute inset-0 flex items-center justify-center">
          <h2 className="text-[#F5F1E9] text-center px-6 text-2xl sm:text-4xl md:text-5xl lg:text-6xl font-light text-balance tracking-wide">
            Fale Connosco
          </h2>
        </div>

        {/* Wave shape at the bottom */}
        <div className="absolute bottom-0 left-0 w-full h-16">
          <svg viewBox="0 0 1200 60" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" className="w-full h-full">
            <path d="M0,60 V30 C150,50 350,40 500,35 C650,30 750,25 900,30 C1050,35 1200,45 1200,45 V60 H0 Z" fill="#F5F1E9"/>
          </svg>
        </div>
      </div>

      {/* Intro */}
      <section className="py-16 px-6 reveal">
        <div className="container mx-auto max-w-3xl text-center">
          <h3 className="text-3xl md:text-4xl font-light text-[#5c7160] mb-8 relative inline-block">
            Como podemos ajudar?
            <span className="absolute -bottom-2 left-1/2 -translate-x-1/2 w-24 h-0.5 bg-[#a5bf99]"></span>
          </h3>
          <p className="text-lg font-light text-[#5c7160] leading-relaxed">
            Estamos à sua disposição para esclarecer dúvidas, falar sobre tratamentos
            ou ajudar a escolher o serviço certo para si.
          </p>

          <div className="w-32 h-0.5 mx-auto mt-8 bg-gradient-to-r from-transparent via-[#c0a080] to-transparent"></div>
        </div>
      </section>

      <section className="pb-16 md:pb-20 px-6 reveal">
        <div className="container mx-auto max-w-5xl">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-10 items-start">

            {/* Contactos */}
            <div className="bg-white rounded-2xl p-6 md:p-8 shadow-sm border border-stone-200/60">
              <CardTitle>Contactos</CardTitle>

              <div className="space-y-4">
                {CONTACT_DETAILS.map(({ label, lines, href, external, compact }) => {
                  const conteudo = (
                    <>
                      <span className="flex-shrink-0 bg-[#a5bf99]/20 group-hover:bg-[#a5bf99]/40 rounded-full p-3 transition-colors">
                        <ContactIcon name={label} />
                      </span>
                      <span className="min-w-0">
                        <span className="block text-sm text-[#5c7160]/70 mb-0.5">{label}</span>
                        {lines.map((linha) => (
                          <span
                            key={linha}
                            className={`block font-light text-[#5c7160] break-words ${
                              compact ? 'text-sm sm:text-base' : 'text-base sm:text-lg'
                            }`}
                          >
                            {linha}
                          </span>
                        ))}
                      </span>
                    </>
                  )

                  // Telefone, email e morada são acionáveis no telemóvel; o horário não.
                  return href ? (
                    <a
                      key={label}
                      href={href}
                      {...(external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
                      className="group flex items-start gap-4 -mx-2 px-2 py-2 rounded-xl hover:bg-[#F5F1E9] transition-colors"
                    >
                      {conteudo}
                    </a>
                  ) : (
                    <div key={label} className="flex items-start gap-4 px-2 py-2">
                      {conteudo}
                    </div>
                  )
                })}
              </div>

              <div className="w-32 h-0.5 my-7 bg-gradient-to-r from-[#c0a080]/50 to-transparent"></div>

              <h5 className="text-lg font-light text-[#5c7160] mb-4">Siga-nos</h5>
              <div className="flex gap-3">
                {SOCIAL_LINKS.map(({ label, href, Icon }) => (
                  <a
                    key={label}
                    href={href}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={label}
                    className="bg-[#a5bf99]/20 hover:bg-[#5c7160] text-[#5c7160] hover:text-white transition-colors duration-300 rounded-full p-3"
                  >
                    <Icon className="h-5 w-5" />
                  </a>
                ))}
              </div>
            </div>

            {/* Mensagem */}
            <div className="bg-white rounded-2xl p-6 md:p-8 shadow-sm border border-stone-200/60">
              <CardTitle>Envie-nos uma mensagem</CardTitle>

              {enviado ? (
                <div className="text-[#5c7160]">
                  <div className="flex items-start gap-3 bg-[#a5bf99]/10 border border-[#a5bf99]/60 rounded-xl p-4">
                    <FaWhatsapp className="h-5 w-5 mt-0.5 flex-shrink-0" />
                    <p className="font-light leading-relaxed">
                      Abrimos o WhatsApp com a sua mensagem já escrita — falta só carregar em
                      enviar. Se não abriu, use o botão abaixo.
                    </p>
                  </div>

                  <div className="flex flex-col sm:flex-row gap-3 mt-6">
                    <a
                      href={construirLinkWhatsApp()}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center justify-center px-6 py-3 rounded-full bg-[#5c7160] hover:bg-[#5c7160]/90 text-white transition-colors duration-300"
                    >
                      <FaWhatsapp className="h-5 w-5 mr-2" />
                      Abrir o WhatsApp
                    </a>
                    <button
                      type="button"
                      onClick={() => {
                        setEnviado(false)
                        setFormData(ESTADO_INICIAL)
                      }}
                      className="inline-flex items-center justify-center px-6 py-3 rounded-full border border-[#5c7160]/25 text-[#5c7160] hover:bg-[#F5F1E9] transition-colors duration-300"
                    >
                      Escrever outra
                    </button>
                  </div>
                </div>
              ) : (
                <form onSubmit={handleSubmit} className="space-y-5">
                  <p className="text-sm font-light text-[#5c7160]/70">
                    A mensagem segue pelo WhatsApp, onde respondemos mais depressa.
                  </p>

                  <Campo id="nome" label="Nome">
                    <input
                      type="text"
                      id="nome"
                      name="nome"
                      value={formData.nome}
                      onChange={handleChange}
                      required
                      className={CAMPO_CLASSES}
                      placeholder="O seu nome"
                    />
                  </Campo>

                  <Campo id="assunto" label="Assunto">
                    <select
                      id="assunto"
                      name="assunto"
                      value={formData.assunto}
                      onChange={handleChange}
                      required
                      className={CAMPO_CLASSES}
                    >
                      {ASSUNTOS.map((opcao) => (
                        <option key={opcao} value={opcao}>
                          {opcao}
                        </option>
                      ))}
                    </select>
                  </Campo>

                  <Campo id="mensagem" label="Mensagem">
                    <textarea
                      id="mensagem"
                      name="mensagem"
                      value={formData.mensagem}
                      onChange={handleChange}
                      required
                      rows={5}
                      className={`${CAMPO_CLASSES} resize-y`}
                      placeholder="Como podemos ajudar?"
                    ></textarea>
                  </Campo>

                  <button
                    type="submit"
                    className="w-full sm:w-auto inline-flex items-center justify-center px-8 py-3 rounded-full bg-[#5c7160] hover:bg-[#5c7160]/90 text-white transition-colors duration-300"
                  >
                    <FaWhatsapp className="h-5 w-5 mr-2" />
                    <span>Enviar pelo WhatsApp</span>
                  </button>
                </form>
              )}
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-16 md:py-20 px-6 bg-[#f3f3eb] reveal">
        <div className="container mx-auto max-w-4xl text-center">
          <h3 className="text-2xl md:text-3xl font-light text-[#5c7160] mb-6">
            Vamos marcar uma sessão?
          </h3>
          <p className="text-lg font-light text-[#5c7160]/80 mb-8">
            Estamos ansiosas para a receber e proporcionar uma experiência de beleza personalizada.
          </p>
          <div className="flex justify-center">
            <BookingButton className="px-8 py-3 text-base md:text-lg">
              <span className="mr-2">Agendar Agora</span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 transition-transform duration-300 group-hover:translate-x-1"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fillRule="evenodd"
                  d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
                  clipRule="evenodd"
                />
              </svg>
            </BookingButton>
          </div>
        </div>
      </section>
    </div>
  )
}

export default Contact
